import React, { useEffect, useState } from "react";
import CalculatorTabs from "./CalculatorTabs/CalculatorTabs";
import Bodyfat from "./CalculatorTabs/Bodyfat";
import Bmi from "./CalculatorTabs/Bmi";

import "./CalculatorTabs/calculators"
import BodyWeightCal from "./CalculatorTabs/BodyWeightCal";
import ChildernHeightPredictor from "./CalculatorTabs/ChildernHeightPredictor";
import Edd from "./CalculatorTabs/Edd";
import HeightCounter from "./CalculatorTabs/HeightCounter";
import WeightConverter from "./CalculatorTabs/WeightConverter";

function Calculator() {
  const [selectedTab, setSelectedTab] = useState("Bodyfat");
  const handleTabSelect = (tab) => {
    setSelectedTab(tab);
  };
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="calculator">

      <h3>Calculator</h3>

      <div className="tabs-sec">


      <div className="row">
        <div className="col-lg-3 col-md-12 col-12">
          <CalculatorTabs onTabSelect={handleTabSelect} />
        </div>
        <div className="col-lg-9 col-md-12 col-12">
          {selectedTab === "Bodyfat" && <Bodyfat />}
          {selectedTab === "BMI" && <Bmi />}
          {selectedTab === "Body_weight_calculator" && <BodyWeightCal />}
          {selectedTab === "Childern_height_predictor" && <ChildernHeightPredictor />}
          {selectedTab === "Edd" && <Edd />}
          {selectedTab === "Height_Converter" && <HeightCounter />}
          {selectedTab === "Weight_Converter" && <WeightConverter />}
        </div>
      </div>
      </div>
    </div>
  );
}

export default Calculator;
